import { PasswordResetData } from 'modules/types/UserPassword';
import { UpdateUserData } from 'modules/types/User';
import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const resetPassword = async (passwordResetData: PasswordResetData) => {
  const body = { ...passwordResetData };
  const response = await axiosInstance.post<PasswordResetData>(
    `${REACT_APP_API_SERVER_URL}/api/reset-password`,
    body,
  );

  return response.status === 200;
};

export const updateProfileData = async (updatedData: UpdateUserData) => {
  const body = { ...updatedData };
  const response = await axiosInstance.post<UpdateUserData>(
    `${REACT_APP_API_SERVER_URL}/api/user-profile/update`,
    body,
  );

  return response.status === 200;
};
